import React from 'react'

const SimplePlan = () => {
  return (
    <div>SimplePlan</div>
  )
}

export default SimplePlan